import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Fab from "@mui/material/Fab";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import StyledCard from "../../shared/general/Card";

import SelectCompany from "../shared/selectCompany";
import CustomPlan from "./customPlan";
import ListEmployee from "./listEmployee";
import DrawerSetting from "./drawerSetting";

import { getShift } from "../../../../actions/shift";

const StyledRoot = styled("div")({
  minHeight: 700,
  backgroundColor: "#FFFFFF !important",
});

const StyledAvatar = styled(Avatar)(({ shift }) => ({
  width: 30,
  height: 30,
  ...(shift === `A` && {
    backgroundColor: "#ffb94e",
  }),
  ...(shift === `D` && {
    backgroundColor: "#fe6c76",
  }),
  ...(shift === `C` && {
    backgroundColor: "#29a2e0",
  }),
  ...(shift === `B` && {
    backgroundColor: "#02bbb5",
  }),
}));

const StyledMenu = styled(Menu)({
  "& .MuiMenu-paper": {
    borderRadius: 8,
    boxShadow:
      "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 12px 24px 0px",
  },
});

const StyledCardShift = styled("div")({
  padding: 16,
  "& .part-one": {
    display: "flex",
    justifyContent: "space-between",
    "& .start-create-date": {
      width: "100%",
      "& .inner": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },
  },
  "& .partTwo": {
    boxShadow: "#f4f6f8 0px 8px 16px 0px",
    backgroundColor: "#ecf7ff",
    color: "#007afe",
    borderRadius: 16,
    marginTop: 8,
    paddingTop: 8,
    paddingBottom: 8,
    textAlign: "center",
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
  },
  "& .partThree": {
    marginTop: 8,
    display: "flex",
    justifyContent: "space-between",
  },
  "& .partFour": {
    height: 30,
    marginTop: 8,
    display: "flex",
    justifyContent: "space-evenly",
  },
});

const StyledPleaseSelectCompany = styled("div")({
  padding: 18,
  width: "100%",
  "& .MuiTypography-root": {
    fontStyle: "oblique",
    letterSpacing: 2,
  },
});

export default function ShiftVendorPage(props) {
  const { result: shiftGroupList } = useSelector((state) => state.shift);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [valueSelected, setValueSelected] = React.useState(null);
  const [menuSelected, setMenuSelected] = React.useState(null);
  const [company, setCompany] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [drawerSetting, setDrawerSetting] = useState({
    isOpen: false,
    data: null
  });

  const OrderShiftName = ["A", "B", "C", "D", "E", "F"];

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const displayTimeType = (shiftType, typeEng) => {
    let FilterType = shiftType
      ? shiftType.find((shift) =>
          shift.nameShiftType? shift.nameShiftType.toLowerCase().includes(typeEng): ""
        )
      : undefined;
    if (FilterType) {
      let splitStartTime = FilterType.timeIn.split(":");
      let splitEndTime = FilterType.timeOut.split(":");
      let startTime = dayjs()
        .hour(splitStartTime[0])
        .minute(splitStartTime[1])
        .format("HH:mm");
      let endTime = dayjs()
        .hour(splitEndTime[0])
        .minute(splitEndTime[1])
        .format("HH:mm");
      return `${startTime} - ${endTime}`;
    } else {
      return "-";
    }
  };

  const handleChangeCompany = (newCompany) => {
    setCompany(newCompany);
    if (newCompany) {
      dispatch(getShift(newCompany.idCompany));
    }
  };

  const handleClickAll = () => {
    setValueSelected(null);
    setMenuSelected(null);
    setBreadcrumbs([]);
    handleCloseMenu();
  };

  const handleClickListName = () => {
    setMenuSelected("list");
    let temp = [];
    temp.push(
      <Link underline="hover" key="1" color="inherit" onClick={handleClickAll}>
        {t("All")}
      </Link>
    );
    temp.push(
      <Link
        underline="hover"
        key="2"
        color="inherit"
        onClick={handleClickListName}
      >
        {valueSelected.nameShiftGroup}
      </Link>
    );
    setBreadcrumbs(temp);
    
  };

  const handleClickEditTimeWorking = () => {
    setMenuSelected("custom");
    let temp = [...breadcrumbs];
    temp.push(
      <Link underline="hover" key="3" color="inherit">
        {t("EditWorkTime")}
      </Link>
    );
    setBreadcrumbs(temp);
  };

  return (
    <StyledRoot className="page">
      <Container maxWidth="lg">
        <div style={{ marginBottom: 8 }}>
          <Typography variant="h4" style={{ paddingTop: 8 }}>
            {t("Shift_Management")}
          </Typography>
        </div>

        <SelectCompany handleChangeCompany={handleChangeCompany} disabled={menuSelected !== null}/>
        <div style={{ marginTop: 16 }}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>

        <Fragment>
          {company ? (
            <Fragment>
              {menuSelected === null && (
                <Fragment>
                  <div style={{ marginTop: 24, paddingBottom: 20 }}>
                    <Typography
                      color="text.third"
                      style={{ fontWeight: 600, fontSize: 14, marginBottom: 8 }}
                    >
                      {t("ShiftList")}
                    </Typography>
                    <Grid container spacing={3}>
                      {shiftGroupList &&
                        shiftGroupList.map((shiftGroup) => (
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={3}
                            key={shiftGroup.nameShiftGroup}
                          >
                            <StyledCard style={{ marginTop: "0 !important" }}>
                              <StyledCardShift>
                                <div className={`part-one`}>
                                  <div className={`start-create-date`}>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      style={{ fontSize: 14 }}
                                    >
                                      {t("Start")}:{" "}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      style={{ fontSize: 14, fontWeight: 500 }}
                                    >
                                      {dayjs(shiftGroup.shiftStartDate).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </Typography>
                                  </div>

                                  <div className={`inner`}>
                                    <IconButton
                                      aria-label="delete"
                                      size="small"
                                      onClick={(event) => {
                                        setValueSelected(shiftGroup);
                                        setAnchorEl(event.currentTarget);
                                      }}
                                    >
                                      <MoreVertIcon fontSize="inherit" />
                                    </IconButton>
                                  </div>
                                </div>
                                <div className={`partTwo`}>
                                  <Typography variant="h5">
                                    {shiftGroup.nameShiftGroup}
                                  </Typography>
                                </div>
                                <div className={`partThree`}>
                                  <Typography color="text.secondary">
                                    {t("Day")}:{" "}
                                  </Typography>
                                  <Typography>
                                    {displayTimeType(
                                      shiftGroup.shiftType,
                                      "day"
                                    )}
                                  </Typography>
                                </div>
                                <div className={`partThree`}>
                                  <Typography color="text.secondary">
                                    {t("Mid")}:{" "}
                                  </Typography>
                                  <Typography>
                                    {displayTimeType(
                                      shiftGroup.shiftType,
                                      "mid"
                                    )}
                                  </Typography>
                                </div>
                                <div className={`partThree`}>
                                  <Typography color="text.secondary">
                                    {t("Night")}:
                                  </Typography>
                                  <Typography>
                                    {displayTimeType(
                                      shiftGroup.shiftType,
                                      "night"
                                    )}
                                  </Typography>
                                </div>
                                <div className={`partFour`}>
                                  {shiftGroup.shiftNumber &&
                                    shiftGroup.shift &&
                                    shiftGroup.shift.map((value, index) => (
                                      <StyledAvatar
                                        shift={`${OrderShiftName[index]}`}
                                        key={value.nameShift}
                                      >
                                        {OrderShiftName[index]}
                                      </StyledAvatar>
                                    ))}
                                </div>
                              </StyledCardShift>
                            </StyledCard>
                          </Grid>
                        ))}
                    </Grid>
                    <StyledMenu
                      id={`more-menu`}
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleCloseMenu}
                    >
                      <MenuItem onClick={() => {
                        setAnchorEl(null);
                        setDrawerSetting({
                          isOpen: true,
                          data: valueSelected
                        })
                      }}>
                        {t("Setting")}
                      </MenuItem>
                      <MenuItem onClick={handleClickListName}>
                        {t("List")}
                      </MenuItem>
                    </StyledMenu>
                  </div>
                </Fragment>
              )}
              {menuSelected === "list" && (
                <ListEmployee
                  selectedCompany={company}
                  shiftGroup={valueSelected}
                  handleClickEditTimeWorking={handleClickEditTimeWorking}
                />
              )}
              {menuSelected === "custom" && (
                <CustomPlan shiftGroup={valueSelected} company={company} />
              )}
            </Fragment>
          ) : (
            <StyledPleaseSelectCompany>
              <Typography color="text.third" align="center">
                ...{t("PleaseSelectCompany")}...
              </Typography>
            </StyledPleaseSelectCompany>
          )}
        </Fragment>
      </Container>
      <DrawerSetting 
        open={drawerSetting.isOpen}
        onClose={() => {
          setDrawerSetting({
            ...drawerSetting,
            isOpen: false
          });
        }}
        data={drawerSetting.data}
      />
    </StyledRoot>
  );
}
